/**
 * @generated SignedSource<<58fa9b2bdea28dc4aed5aea4f2991dfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrganizationDashboard_organization$data = {
  readonly reportMetrics: ReadonlyArray<{
    readonly name: string;
    readonly value: number | null;
  } | null>;
  readonly totalCompanies: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "OrganizationDashboard_organization";
};
export type OrganizationDashboard_organization$key = {
  readonly " $data"?: OrganizationDashboard_organization$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrganizationDashboard_organization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrganizationDashboard_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReportMetricResult",
      "kind": "LinkedField",
      "name": "reportMetrics",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "totalCompanies",
      "args": [
        {
          "kind": "Literal",
          "name": "includeDeleted",
          "value": "NO"
        }
      ],
      "concreteType": "CompaniesConnection",
      "kind": "LinkedField",
      "name": "companies",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "companies(includeDeleted:\"NO\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "8ec6c194948467fe830b5ce6e5cac2e9";

export default node;
